import Link from 'next/link';

import LogoSvg from '@/public/images/logo.svg';
import WhiteLogoSvg from '@/public/images/whiteLoogo.svg';
import useIsMobile from '@/src/hooks/useIsMobile';
import useRoutePaths from '@/src/hooks/useRoutePaths';
import {useTheme} from '@/src/hooks/useTheme';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Button, SectionContainer, Text} from '../../../ui';
import css from '../styles/Header.module.css';

interface HeaderProps {
  withSignUpButton?: boolean;
  logoLink?: string;
}

const Header = ({withSignUpButton, logoLink}: HeaderProps) => {
  const {isMaxWidth900} = useIsMobile();
  const {INDEX_ROUTE, SIGN_UP_ROUTE} = useRoutePaths();
  const {isDarkMode} = useTheme();

  return (
    <header className={css.header}>
      <SectionContainer>
        <div className={css.headerInner}>
          <Link href={logoLink ? logoLink : INDEX_ROUTE.getLink()}>
            <a className={css.logo} aria-label={'medyoucate logo'}>
              {isDarkMode ? <WhiteLogoSvg /> : <LogoSvg />}
            </a>
          </Link>

          {withSignUpButton && !isMaxWidth900 && (
            <div className={css.rightSide}>
              <Text color={Text.COLOR.GREY} fontSize={Text.FONT_SIZE.SIZE_17}>
                <TextLocal id="sing-in.need-account-q" />
              </Text>
              <div className={css.singInWrapper}>
                <Link href={SIGN_UP_ROUTE.getLink()}>
                  <a>
                    <Button
                      height={Button.HEIGHT.SMALL}
                      color={Button.COLOR.SECONDARY}
                    >
                      <TextLocal id="sing-in.sing-up" />
                    </Button>
                  </a>
                </Link>
              </div>
            </div>
          )}
        </div>
      </SectionContainer>
    </header>
  );
};

export default Header;
